import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconType, Icons } from '../../../../constants/icons';
import './HelpCreateTemplate.css';

type HelpCreateTemplateProps = {
  remain: number;
  onClickicon1: () => void;
  onClickicon2: () => void;
  onClickicon3: () => void;
  onClickicon4: () => void;
};

export const HelpCreateTemplate = memo(
  ({
    remain,
    onClickicon1, // whatsapp
    onClickicon2, // line
    onClickicon3, // skype
    onClickicon4, // wechat
  }: HelpCreateTemplateProps) => {
    const { t } = useTranslation();

    return (
      <div className="help">
        <div className="centered-container">
          <div className="logo-container">
            <img
              className="logo-icon"
              src={Icons[IconType.CreateGameContent]}
            />
          </div>
          <div className="text-belowTitle">
            {t('Provide the content you want to convert to AI Memory Games.')}
          </div>

          <div className="grey-area">
            <div className="grey-title">{t('Guidelines')}</div>
            <ul className="grey-list">
              <li>{t('Only provide plain text Guideline 1')}</li>
              <li>
                {t(
                  'Provide your username together with your content Guideline 2',
                )}
              </li>
              <li>{t('No more than 3 pages of content Guideline 3')}</li>
            </ul>
          </div>

          <div className="text-belowGrey">
            {t('Remaining Content Customization Service')}
          </div>
          <p className={`remain ${remain === 0 ? 'zero-remain' : ''}`}>
            <p className="firstNum">{remain}</p>
            <p className="divider">/</p>
            <p className="secondNum">12</p>
          </p>
          <hr className="pageDiv" />
          <div className="text-bot">
            {t('Provide your content via the following methods.')}
          </div>
          <div className={`icon-area ${remain === 0 ? 'disabled' : ''}`}>
            <img
              className="icon"
              src={Icons[IconType.InstantMessageWhatsApp]}
              onClick={remain > 0 ? onClickicon1 : undefined}
            />
            <img
              className="icon"
              src={Icons[IconType.InstantMessageLine]}
              onClick={remain > 0 ? onClickicon2 : undefined}
            />
            <img
              className="icon"
              src={Icons[IconType.InstantMessageSkype]}
              onClick={remain > 0 ? onClickicon3 : undefined}
            />
            <img
              className="icon"
              src={Icons[IconType.InstantMessageWechat]}
              onClick={remain > 0 ? onClickicon4 : undefined}
            />
          </div>
        </div>
      </div>
    );
  },
);
